import { DateTime } from 'luxon';

import { CopilsSummaryApi } from '@apps/dash/api/models/copils-summary-api';
import { CopilMonth } from '@apps/dash/models/copil-month';

export class CopilsSummary
{
    public nbOld: number;
    public nbPlanified: number;
    public nextCopilDate: DateTime;
    public copilMonths: CopilMonth[];

    public static mapperFromApi (source: CopilsSummaryApi): CopilsSummary
    {
        const target: CopilsSummary = Object.assign(new CopilsSummary(), source);

        if (source.nextCopilDate)
        {
            target.nextCopilDate = DateTime.fromISO(source.nextCopilDate);
        }

        target.copilMonths = source.copilMonths.map(cm => CopilMonth.mapperFromApi(cm));

        return target;
    }
}